import apiService from './apiService';

const whatsappSettingsService = {
  // Returns: { companyPhone, hasToken, webhookSecret, channelId, whatsappChannelId }
  getWhatsappSettings: async () => {
    try {
      const response = await apiService.get('/whatsapp-settings');
      return response.data;
    } catch (error) {
      console.error('Error fetching WhatsApp settings:', error);
      throw error;
    }
  },

  updateWhatsappSettings: async ({ wasenderapiToken, companyPhone, regenerateWebhookSecret } = {}) => {
    const response = await apiService.put('/whatsapp-settings', {
      wasenderapiToken,
      companyPhone,
      regenerateWebhookSecret,
    });
    return response.data;
  },

  testConnection: async () => {
    const response = await apiService.post('/whatsapp-settings/test');
    return response.data;
  },
};

export default whatsappSettingsService;
